
export enum AppTheme {
  ZEN = "Zen",
  BAMBOO = "Bamboo",
  OCEAN = "Ocean"
}

export enum LogType {
  ISSUE = "Issue",
  EXTRA_WORK = "ExtraWork",
  DELAY = "Delay",
  DISCOVERY = "Discovery",
  CLARIFICATION = "Clarification",
  SAFETY = "Safety"
}

export enum LogStatus {
  NEW = "New",
  REVIEWED = "Reviewed",
  FLAGGED_FOR_CO = "FlaggedForCO",
  LINKED_TO_CO = "LinkedToCO"
}

export enum ScopeClassification {
  IN_SCOPE = "InScope",
  OUT_OF_SCOPE_LIKELY = "OutOfScopeLikely",
  AMBIGUOUS = "Ambiguous"
}

export enum RecommendedAction {
  NO_ACTION = "NoAction",
  CLARIFY_VIA_RFI = "ClarifyViaRFI",
  DRAFT_CO = "DraftCO",
  FLAG_FOR_PM_REVIEW = "FlagForPMReview"
}

export enum CoStatus {
  DRAFT = "Draft",
  SUBMITTED = "Submitted",
  APPROVED = "Approved",
  REJECTED = "Rejected"
}

export enum CauseType {
  OWNER_REQUEST = "Owner Request",
  UNFORESEEN = "Unforeseen Condition",
  DESIGN_ISSUE = "Design Issue",
  COORDINATION = "Coordination Issue",
  OTHER = "Other"
}

export interface WbsItem {
  id: string;
  projectId: string;
  code: string;
  title: string;
  description: string;
  scopeType: "Base" | "Allowance" | "Alt" | "Exclusion";
}

export interface LogEntry {
  id: string;
  projectId: string;
  date: string;
  authorName: string;
  authorRole: string;
  location?: string;
  logType: LogType;
  text: string;
  tags: string[];
  photos: string[];
  status: LogStatus;
  linkedWbsItemIds?: string[];
  linkedChangeOrderId?: string | null;
  aiAnalysis?: ScopeAnalysis;
}

export interface ScopeAnalysis {
  logId: string;
  scopeClassification: ScopeClassification;
  causeType: CauseType;
  recommendedAction: RecommendedAction;
  wbsMatches: {
    id: string;
    confidence: number;
    rationale: string;
  }[];
  summary: string;
  notesForPM: string[];
  financialImpactRationale: string;
}

export interface MarginTrajectoryPoint {
  month: string;
  expectedProfit: number;
  actualProfit: number;
  forecastedProfit: number;
}

export interface SubcontractorImpact {
  name: string;
  status: "OnTrack" | "AtRisk" | "Delayed";
  variance: number;
}

export interface Project {
  id: string;
  name: string;
  location: string;
  contractAmount: number;
  expectedProfit: number; // Original Fee
  costToDate: number;
  unbilledExposure: number;
  marginRetentionScore: number; // 0-100 percentage
  profitVelocity: number; // Burn rate of profit per month
  marginStatus: "Green" | "Yellow" | "Red";
  description: string;
  marginTrajectory: MarginTrajectoryPoint[];
  subcontractorImpacts: SubcontractorImpact[];
  cpi: number;
  forecastAtCompletion: number;
}
